import React from 'react'

const MemberView = (props) => {
    return (
        <div className='member-card-container'>
            {props.children}
        </div>
    )
}

export default MemberView